import { useEffect, useState } from "react";
import {
    collection,
    onSnapshot,
    query,
} from "firebase/firestore";
import { db } from "../firebase";

/**
 * Real-time listener for the "options" subcollection in a form.
 */
export function useOptions(formId) {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!formId) return;

        const q = query(collection(db, "forms", formId, "options"));

        const unsubscribe = onSnapshot(
            q,
            (snapshot) => {
                // Sort locally by name to avoid missing index errors in Firestore
                const data = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                })).sort((a, b) => (a.name || "").localeCompare(b.name || ""));
                setOptions(data);
                setLoading(false);
            },
            (err) => {
                console.error("Error listening to options:", err);
                setError(err.message);
                setLoading(false);
            }
        );

        return () => unsubscribe();
    }, [formId]);

    return { options, loading, error };
}
